import React from 'react';
import { AllBrokerRepo } from '@trader-dashboard/shared';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BrokerSelectorProps {
  value: string;
  onValueChange: (brokerId: string) => void;
  disabled?: boolean;
}

export const BrokerSelector: React.FC<BrokerSelectorProps> = ({
  value,
  onValueChange,
  disabled = false,
}) => {
  const brokers = AllBrokerRepo.getAllBrokers();

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select broker" />
      </SelectTrigger>
      <SelectContent>
        {brokers.map((broker) => (
          <SelectItem key={broker.id} value={broker.id}>
            <div className="flex items-center gap-2">
              <img
                src={broker.logo}
                alt={broker.name}
                className="h-5 w-5 object-contain"
                onError={(e) => {
                  // Fallback if logo fails to load
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
              <span>{broker.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
